// One-time acceptance of the posting rules, remembered per device.
//
// Guideline 1.2 wants posters bound to terms with no tolerance for
// objectionable content — this is where they agree to them. It lives in its
// own module rather than in App.js so that pages App.js imports (the
// Complaint Line) can use it without an import cycle back through App.
const UGC_TERMS_KEY = "btn-ugc-terms-accepted";

export function hasAcceptedPostingTerms() {
  try {
    return localStorage.getItem(UGC_TERMS_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function acceptPostingTerms() {
  try {
    localStorage.setItem(UGC_TERMS_KEY, "1");
  } catch (e) {
    // private mode / storage disabled — the checkbox just asks again next time
  }
}
